import api from './api';

export async function getConfigurations(token: string): Promise<any> {
  let baseURL = '/configurations';
  const response = await api.get(baseURL, {
    headers: {
      'x-access-token': token,
    },
  });

  return response.data;
}
